import { ResponseInventoryControlRegistry } from "api/generated";
import {
  getRowClassNameByPeriod,
  getStockControlByPeriodColumns,
} from "./StockControlColumns";
import { Fragment, useState } from "react";
import { useIsMobile } from "hooks/useIsMobile";
import { Table } from "antd";
import moment from "moment";
import StockDifferenceViewer from "./StockDifferenceViewer";

interface StockControlTableByPeriodProps {
  registries: ResponseInventoryControlRegistry[];
  currentPage: number;
  pageSize: number;
  totalItems: number;
  loading: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  recalculatePeriod: (dateToReCalculate: moment.Moment) => void;
  onRegisterManualMeasurement?: (dateToReCalculate: moment.Moment) => void;
}

function StockControlTableByPeriod({
  registries,
  currentPage,
  pageSize,
  totalItems,
  loading,
  onPageChange,
  onPageSizeChange,
  recalculatePeriod,
  onRegisterManualMeasurement,
}: StockControlTableByPeriodProps) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const { isMobile } = useIsMobile();
  const [periodRecord, setPeriodRecord] =
    useState<ResponseInventoryControlRegistry>();
  const columnActions = {
    onRecalculatePeriod: (record: ResponseInventoryControlRegistry) => {
      recalculatePeriod(moment(record.registeredDate));
    },
    onViewDetails: (record: ResponseInventoryControlRegistry) => {
      setPeriodRecord(record);
      setIsDetailsOpen(true);
    },
    onRegisterManualMeasurement: (record: ResponseInventoryControlRegistry) => {
      onRegisterManualMeasurement?.(moment(record.registeredDate));
    },
    showRegenerate: true,
    isMobile,
  };
  const columns = getStockControlByPeriodColumns(columnActions);

  function onClose() {
    setIsDetailsOpen(false);
    setPeriodRecord(undefined);
  }
  return (
    <Fragment>
      <Table<ResponseInventoryControlRegistry>
        columns={columns}
        dataSource={registries}
        scroll={{ x: "max-content" }}
        loading={loading}
        rowClassName={getRowClassNameByPeriod}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "15", "20", "25"],
          showTotal: (total) => `Total ${total} elementos`,
          pageSize: pageSize,
          current: currentPage,
          total: totalItems,
          position: ["bottomLeft"],
          onChange: (page) => {
            onPageChange(page);
          },
          onShowSizeChange(_, size) {
            onPageSizeChange(size);
          },
        }}
      />

      <StockDifferenceViewer
        periodRecord={periodRecord}
        onClose={onClose}
        isDetailsOpen={isDetailsOpen}
      />
    </Fragment>
  );
}

export default StockControlTableByPeriod;
